import { Routes } from '@angular/router'
import { authGuard } from './guards/auth.guard'
import { productAccessGuard } from './guards/product-access.guard'

export const routes: Routes = [
  // Auth (unauthenticated)
  { path: 'auth-start', loadComponent: () => import('./pages/auth-start/auth-start.component').then(m => m.AuthStartComponent) },
  { path: 'auth-end', loadComponent: () => import('./pages/auth-end/auth-end.component').then(m => m.AuthEndComponent) },
  { path: 'teams-no-access', loadComponent: () => import('./pages/teams-no-access/teams-no-access.component').then(m => m.TeamsNoAccessComponent) },
  { path: 'error', loadComponent: () => import('./pages/error/error.component').then(m => m.ErrorComponent) },
  { path: 's/:id', loadComponent: () => import('./pages/shared-chat/shared-chat.component').then(m => m.SharedChatComponent) },

  // Authenticated routes
  {
    path: '',
    loadComponent: () => import('./layout/layout.component').then(m => m.LayoutComponent),
    canActivate: [authGuard],
    canActivateChild: [productAccessGuard],
    children: [
      { path: '', loadComponent: () => import('./pages/home/home.component').then(m => m.HomeComponent) },
      { path: 'product-disabled', loadComponent: () => import('./pages/product-disabled/product-disabled.component').then(m => m.ProductDisabledComponent) },
      { path: 'c/:id', loadComponent: () => import('./pages/chat/chat.component').then(m => m.ChatComponent) },
      { path: 'folders/:id', loadComponent: () => import('./pages/folder/folder.component').then(m => m.FolderPageComponent) },
      { path: 'folder/:id', redirectTo: 'folders/:id', pathMatch: 'full' },
      { path: 'channels/:id', loadComponent: () => import('./pages/channel/channel.component').then(m => m.ChannelComponent) },
      { path: 'notes/:id', loadComponent: () => import('./pages/note/note.component').then(m => m.NoteComponent) },
      { path: 'account', loadComponent: () => import('./pages/account/account.component').then(m => m.AccountComponent) },
      { path: 'playground/completions', loadComponent: () => import('./pages/playground/playground.component').then(m => m.PlaygroundComponent) },

      // Workspace
      { path: 'workspace/knowledge', loadComponent: () => import('./pages/workspace/knowledge/list/knowledge-list.component').then(m => m.KnowledgeListComponent) },
      { path: 'workspace/knowledge/create', loadComponent: () => import('./pages/workspace/knowledge/create/knowledge-create.component').then(m => m.KnowledgeCreateComponent) },
      { path: 'workspace/knowledge/:id', loadComponent: () => import('./pages/workspace/knowledge/detail/knowledge-detail.component').then(m => m.KnowledgeDetailComponent) },
    ]
  },
  { path: '**', redirectTo: '' }
]
